import { useSyncExternalStore } from 'react';
import { type Embedder, getEmbedderByHostname } from '@/config/embedders';
import { getIframeEnvironment } from '@/helpers/iframe';

// The embedding context is fixed for the document's lifetime, so there is
// nothing to subscribe to — the no-op store never notifies.
const subscribe = () => () => {};

// Resolves to the registry `Embedder` (a stable module constant) framing the
// app, or `undefined`. Referentially stable across calls, as `useSyncExternalStore`
// requires.
const getSnapshot = (): Embedder | undefined => getEmbedderByHostname(getIframeEnvironment().host);

// The server can't know the embedder, so it always renders as not-embedded;
// `useSyncExternalStore` reconciles to the client value after hydration without
// a mismatch warning.
const getServerSnapshot = (): Embedder | undefined => undefined;

/**
 * The embedder currently framing the app (Safe, Mellow, …), or `undefined` when
 * not embedded by a known partner. Client-only — reads `document.referrer` /
 * `window.location.ancestorOrigins` via {@link getIframeEnvironment}.
 */
export const useEmbedder = () => {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};